<template>
    <div class="create-customer-group-form">
        <div class="form">
            <div class="field">
                <label class="label">{{ $t("wp.broadcast.groupName") }}</label>
                <a-input ref="userNameInput" v-model="groupName" :placeholder="$t('wp.groupNameSearch')">
                    <a-icon slot="prefix" type="user" />
                    <a-tooltip slot="suffix" :title="$t('wp.groupNameDesc')">
                        <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
                    </a-tooltip>
                </a-input>
            </div>
            <a-divider />
            <div class="buttons">
                <a-button @click="cancel" :disabled="loading">{{ $t("wp.cancel") }}</a-button>
                <a-button type="primary" @click="save" :disabled="loading" :loading="loading"
                    >{{ $t("wp.save") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import WHATSAPP_API from "../../../../../api/whatsapp";
import _ from "lodash";
import { message } from "ant-design-vue";

export default {
    name: "CreateCustomerGroupWithNumbers",
    props: {
        contacts: {
            type: Array,
            required: true,
            default: () => [],
        },
        onCompleted: {
            type: Function,
            required: true,
        },
        onCancelled: {
            type: Function,
            required: true,
        },
        isBusiness: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            groupName: "",
            loading: false,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        save() {
            this.loading = true;
            WHATSAPP_API.BROADCAST.createGroup(this.groupName, this.contacts, _.get(this.user, "_id"), this.isBusiness)
                .then((res) => {
                    message.success("Group created successfully");
                    this.onCompleted(res.data);
                })
                .catch((err) => {
                    message.error("Error creating group");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        cancel() {
            this.onCancelled();
        },
    },
};
</script>

<style lang="scss">
.create-customer-group-form {
    .form {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .buttons {
            display: flex;
            justify-content: flex-end;
            gap: 5px;
        }
    }
}
</style>
